import { NextPage } from 'next'
import router from 'next/router'
import { useMemo } from 'react'

import { useUser } from 'src/providers/UserProvider'

import { LoadingSpinner } from 'src/components/atoms/LoadingSpinner'
import { Page } from 'src/components/layouts/Page'

import { dashboardPath } from 'src/config/paths'
import { ActiveProfileType, NavigationContext } from 'src/types/account'
import { withAuthRequired } from 'src/utils/auth'

import { PlanterDashboardPanel } from '../../components/organisms/Dashboard/boards/planter'

const PlanterDashboardPage: NextPage = () => {
  const { user, isLoading } = useUser()

  const content = useMemo(() => {
    if (isLoading) {
      return <LoadingSpinner isLoading />
    }

    if (user && user.ActiveProfileType === ActiveProfileType.Funder) {
      router.push(dashboardPath())
    }

    return <PlanterDashboardPanel />
  }, [isLoading, user])

  return (
    <Page
      title='Planter Dashboard'
      navigationContext={NavigationContext.Planter}
      isFullWidth
    >
      <div className='2xl:max-w-[1220px] flex flex-col gap-5 sm:gap-10 mx-4 md:mx-[60px] lg:mx-11 xl:mx-[110px] 2xl:mx-auto py-[30px] md:py-12 xl:py-[60px]'>
        {content}
      </div>
    </Page>
  )
}

export default withAuthRequired(PlanterDashboardPage)
